var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 450 450"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225.26,
    cy: 225.74,
    r: 184.32,
    fill: "#fe646f",
    "data-original": "#fe646f",
    transform: "rotate(-45 225.232 225.798)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e9ed",
    d: "M225.26 281.35c-4.09 0-7.59-3.49-8.3-8.29l-20.92-141.1c-2.63-17.77 8.85-34.06 24-34.06h10.43c15.15 0 26.63 16.29 24 34.06l-20.92 141.1c-.7 4.8-4.2 8.29-8.29 8.29zm19.14 53.08c0-10.54-8.6-19.14-19.14-19.14s-19.14 8.6-19.14 19.14 8.6 19.14 19.14 19.14 19.14-8.59 19.14-19.14z",
    "data-original": "#e6e9ed"
  }))));
};
export default SvgError;